import '../../assets/css/loader.scss'

export const Loader = () => {
    return (
        <div className="loader-bg">
            <div className="loader-track">
                <div className="loader-fill"/>
            </div>
        </div>
    );
};
